/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDocumentDownloadUrl200Response
 */
export interface GetDocumentDownloadUrl200Response {
    /**
     * 
     */
    url: string;
}

/**
 * Check if a given object implements the GetDocumentDownloadUrl200Response interface.
 */
export function instanceOfGetDocumentDownloadUrl200Response(value: object): value is GetDocumentDownloadUrl200Response {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function GetDocumentDownloadUrl200ResponseFromJSON(json: any): GetDocumentDownloadUrl200Response {
    return GetDocumentDownloadUrl200ResponseFromJSONTyped(json, false);
}

export function GetDocumentDownloadUrl200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentDownloadUrl200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function GetDocumentDownloadUrl200ResponseToJSON(json: any): GetDocumentDownloadUrl200Response {
    return GetDocumentDownloadUrl200ResponseToJSONTyped(json, false);
}

export function GetDocumentDownloadUrl200ResponseToJSONTyped(value?: GetDocumentDownloadUrl200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

